import {useState} from 'react';

import {globalWindow} from '../../../libs/shared/core/src/helpers/browser/browserHelpers';
import {useInitialEffect} from '../../../libs/shared/core/src/helpers/react/hooks/useEffectHelpers';

export function useOnline() {
  const [online, setOnline] = useState(() => navigator.onLine);

  useInitialEffect(() => {
    function onChange() {
      setOnline(navigator.onLine);
    }

    onChange();

    globalWindow.addEventListener('offline', onChange);
    globalWindow.addEventListener('online', onChange);

    return () => {
      globalWindow.removeEventListener('offline', onChange);
      globalWindow.removeEventListener('online', onChange);
    };
  });

  return online;
}
